import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Modal from 'components/Shared/Modals';
import Button from 'components/Shared/Common/Button';
import {useKey} from 'react-use';

const formatMessages = intl => () => ({
    modalTitle: intl.formatMessage({
        id: 'modal.deleteAccount.title',
        defaultMessage: 'Supprimer le compte'
    }),
    modalContent: intl.formatMessage({
        id: 'modal.deleteAccount.content',
        defaultMessage: 'Êtes-vous sûr(e) de vouloir supprimer votre compte ? Cette action est irréversible. Vous perdrez tous vos contacts, historiques, fichiers...'
    }),
    buttonCancel: intl.formatMessage({
        id: 'global.button.cancel',
        defaultMessage: 'Annuler'
    }),
    buttonValid: intl.formatMessage({
        id: 'global.button.confirm',
        defaultMessage: 'Confirmer'
    })
});

const DeleteAccount = ({
    intl,
    onClose,
    onSubmit
}) => {
    const i18n = formatMessages(intl)();

    useKey('Enter', onSubmit);

    return (
        <Modal
            isOpen
            title={i18n.modalTitle}
            footer={(
                <>
                    <Button
                        isTransparent
                        onClick={onClose}
                    >
                        {i18n.buttonCancel}
                    </Button>
                    <Button
                        color="danger"
                        onClick={onSubmit}
                    >
                        {i18n.buttonValid}
                    </Button>
                </>
            )}
            onClose={onClose}
        >
            {i18n.modalContent}
        </Modal>
    );
};


DeleteAccount.propTypes = {
    intl: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default injectIntl(DeleteAccount);
